import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { authSelector } from "../redux/slices/authSlice";
import { deleteTransaction } from "../api/transaction";
import { deleteImportListProduct } from "../api/product";
import { useLocation } from "react-router-dom";
import { deleteBatchProcess, deleteOrder } from "../api/order";
import { deleteDispute } from "../api/order/disputes-admin";
import { Fade, Tooltip } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "30px 40px",
  outline: "none",
  borderRadius: "10px",
};

export default function ConfirmationModal({ title, confirm, icon, elementId }) {
  const [open, setOpen] = React.useState(false);
  const { loggedUser } = useSelector(authSelector);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const location = useLocation().pathname;


  const handleDelete = () => {
    if (location === "/admin/orders") {
      dispatch(deleteOrder(elementId));
      handleClose();
    }
    if (location === "/admin/orders/batch-process") {
      dispatch(deleteBatchProcess(elementId));
      handleClose();
    }
    if (location === "/admin/orders/dispute-list") {
      dispatch(deleteDispute(elementId));
      handleClose();
    }
    if (location === "/admin/payments") {
      dispatch(deleteTransaction(elementId));
      handleClose();
    }
    if (loggedUser?.user?.role !== "admin") {
      dispatch(deleteImportListProduct(elementId));
      handleClose();
    }
  };

  return (
    <div>
      {icon === "delete" ? (
        <Tooltip
        title="Delete Batch Process"
        placement="top-end"
        TransitionComponent={Fade}
      >

        <Icon
          icon="carbon:trash-can"
          width="20"
          height="20"
          style={{ cursor: "pointer" }}
          onClick={handleOpen}
        />
      </Tooltip>
      ) : (
        // <DeleteOutline
        //   onClick={handleOpen}
        //   sx={{ marginRight: "20px", cursor: "pointer", color: "gray" }}
        // />
        <Close
          onClick={handleOpen}
          sx={{ cursor: "pointer", color: "gray", fontSize: "14px" }}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-description"
            variant="h2"
            component="h2"
            sx={{ fontSize: "24px", fontWeight: "600" }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              marginTop: "30px",
            }}
          >
            <Button
              variant="red"
              sx={{ width: "auto", marginRight: "20px" }}
              onClick={handleDelete}
            >
              {confirm}
            </Button>
            <Button
              variant="deepblue"
              sx={{ width: "auto" }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
